import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { useShallow } from 'zustand/shallow';
import { draggableDataRegistry } from './dataRegistry.js';
import { dndEvents } from './dndEvents.js';
import { dndLogger } from './logger.js';
export const useDndStore = create()(subscribeWithSelector((set, get) => ({
    domOverlayElement: null,
    svgOverlayElement: null,
    candidate: null,
    dragging: null,
    dragGesture: { x: 0, y: 0, xOffset: 0, yOffset: 0 },
    overRegion: null,
    domOverlayRef: (element) => {
        set({ domOverlayElement: element });
    },
    svgOverlayRef: (element) => {
        set({ svgOverlayElement: element });
    },
    setCandidate: (id) => {
        dndLogger.debug(`Drag candidate set: ${id}`);
        const current = get().candidate;
        if (current && current !== id) {
            dndEvents.emit('cancel', current);
        }
        set({ candidate: id, overRegion: null });
        if (id) {
            dndEvents.emit('candidate', id);
        }
    },
    startDrag: (id) => {
        dndLogger.debug(`Drag locked in by ${id}`);
        const current = get().dragging;
        if (current && current !== id) {
            dndEvents.emit('cancel', current);
        }
        set({
            dragging: id,
            candidate: null,
            overRegion: null,
        });
        if (id) {
            dndEvents.emit('start', id);
        }
    },
    endDrag: (gesture) => {
        const { dragging, overRegion } = get();
        if (dragging) {
            if (overRegion) {
                dndEvents.emit('drop', dragging, overRegion, gesture);
            }
            else {
                dndEvents.emit('cancel', dragging);
            }
        }
        set({
            dragging: null,
            overRegion: null,
            candidate: null,
        });
    },
    cancelDrag: () => {
        const { dragging } = get();
        if (dragging) {
            dndEvents.emit('cancel', dragging);
        }
        set({
            dragging: null,
            candidate: null,
            overRegion: null,
        });
    },
    setOverRegion: (regionId) => {
        if (get().overRegion === regionId)
            return;
        set({ overRegion: regionId });
    },
})));
window.dndStore = useDndStore; // For debugging in browser console
export function useDraggedData() {
    return useDndStore(useShallow((state) => {
        const dragging = state.dragging;
        if (!dragging)
            return null;
        return {
            id: dragging,
            data: draggableDataRegistry.get(dragging),
        };
    }));
}
//# sourceMappingURL=dndStore.js.map